import {reduce, isFunction} from 'lodash';

/*
 * In `createRosettaContainer.js, we merge `this.options` and `this.defaults`
 * into `this` early on for easy access. When doing so, we should also
 * perform this extra step of making sure all methods are bound to `this`.
 *
 * Why do we need to do this?
 *
 * Look at how we pass in methods like `this.contentAboveModules` to, say,
 * <SecondaryWrapper/>. Those methods count on the `this.props` of this file.
 * They were written back when ALL logic was in this file.
 *
 * We need to bind all those methods to `this`, as in `createRosettaContainer`.
 * in order for them to work.
 *
 * If we wanted to get rid of this function, we could refactor all of the
 * methods in `options` and `defaults` to take params instead of relying on
 * `this` so heavily.
 */
const ensureAllFunctionsAreBound = (
  objectThatContainsFunctionsAndOtherThings, myThis
) =>
  reduce(
    objectThatContainsFunctionsAndOtherThings,
    (acc, value, key) => {
      acc[key] = isFunction(value) ? value.bind(myThis) : value;
      return acc;
    },
    {}
  );

export default ensureAllFunctionsAreBound;
